import "./App.css";
import NavigationServicesHeader from "./Header/NavigationServicesHeader";
import TokenReceiver from "./Components/TokenReceiver";
import Dashboardheader from "./Header/Dashboardheader";
import LogOut from "./Components/Logout";
import GenerationReceipt from "./Components/EntryForms/DH_APSHCL/GenerationReceipt";
import GenerationPayment from "./Components/EntryForms/DH_APSHCL/GenerationPayment";
import GenerationJournal from "./Components/EntryForms/DH_APSHCL/GenerationJournal";
import InterBankTransfer from "./Components/EntryForms/DH_APSHCL/InterBankTransfer";
import OnlineJournal from "./Components/EntryForms/DH_APSHCL/OnlineJournal";
import SalaryJournal from "./Components/EntryForms/DH_APSHCL/SalaryJournal";
import SubHeadMaster from "./Components/EntryForms/DH_APSHCL/SubHeadMaster";
import BankBook from "./Components/Reports/DH_APSHCL/BankBook";
import BankSubsidary from "./Components/Reports/DH_APSHCL/BankSubsidary";
import CbReceipts from "./Components/Reports/DH_APSHCL/CbReceipts";
import CbPayments from "./Components/Reports/DH_APSHCL/CbPayments";
import Jvoucher from "./Components/Reports/DH_APSHCL/Jvoucher";
import HeadWiseDetails from "./Components/Reports/DH_APSHCL/HeadWiseDetails";
import SubLedger from "./Components/Reports/DH_APSHCL_GMF1/SubLedger";
import Jregister from "./Components/Reports/DH_APSHCL_GMF1/Jregister";
import Pr_Cb from "./Components/Reports/DH_APSHCL_GMF1/Pr_Cb";
import GLedger from "./Components/Reports/DH_APSHCL/GLedger";
import Expenditure from "./Components/Reports/DH_APSHCL_GMF1/Expenditure";
import Review from "./Components/Reports/DH_APSHCL_GMF1/Review";
import BankBalances_Apshcl from "./Components/Reports/APSHCL/BankBalances";
import BankBookReport_Apshcl from "./Components/Reports/APSHCL/BankBookReport";
import BankAccountConfirm_GMF from "./Components/EntryForms/GMF1/BankAccountConfirm";
import EmployeeConfirmation from "./Components/EntryForms/GMF1/EmployeeConfirmation";
import Confirm_Emp_OnRolls from "./Components/PayrollReports/DH_APSHCL_GMF1_GMADM/Confirm_Emp_OnRolls";
import GeneratedMonthlyPayBill from "./Components/PayrollReports/DH_GMADM_GMF1/GeneratedMonthlyPayBill";
import MonthlyPaybillConfirmation from "./Components/PayrollReports/DH_APSHCL_GMADM/MonthlyPaybillConfirmation";
import EmployeePayParticulars from "./Components/PayrollReports/DH_APSHCL/EmployeePayParticulars";
import HousingExpenditureReport from "./Components/HousingReports/HousingExpenditureReport";
import HousingIncomeReport from "./Components/HousingReports/HousingIncomeReport";
import ChangePassword from "./Components/ChangePassword";
import ChangeUser from "./Components/ChangeUser";
import NpiPhysicalProgressReport from "./Components/HousingReports/NpiPhysicalProgressReport";
import ApHomesBeneficiaryPaymentReport from "./Components/HousingReports/ApHomesBeneficiaryPaymentReport";
import PaymentCementReleased from "./Components/HousingReports/PaymentCementReleased";
import AddService from "./Components/AddService";
import RoleServiceMapping from "./Components/RoleServiceMapping";
import VariationInCalculation from "./Components/PayrollReports/APSHCL_GMF1/VariationInCalculation";
import MaterialPatchDetails from "./Components/GstReports/MaterialPatchDetails";
import MaterilaTypeDetails from "./Components/GstReports/MaterilaTypeDetails";
import DistrictwiseTransfer_Gmadm from "./Components/EntryForms/GMADM/DistrictwiseTransfer";
import DistrictwiseDesignationCount from "./Components/PayrollReports/APSHCL_GMF1_GMADM/DistrictwiseDesignationCount";
import NewEmpRegistration from "./Components/EntryForms/GMF1_GMADM/NewEmpRegistration";
import HeadsMaster from "./Components/EntryForms/APSHCL/HeadsMaster";
import JourrnalVoucherEdit from "./Components/EntryForms/APSHCL/JourrnalVoucherEdit";
import EmpDataCount from "./Components/PayrollReports/GMADM/EmpDataCount";
import UpdateGeneratePaybill from "./Components/PayrollReports/GMADM/UpdateGeneratePaybill";
import BankEntryScreen from "./Components/EntryForms/DH_APSHCL/BankEntryScreen";
import EmpDetailsCommonEdit from "./Components/PayrollReports/DH_APSHCL_GMADM/EmpDetailsCommonEdit";
import JournalVoucherRepNav from "./Components/Reports/DH_APSHCL/JournalVoucherRepNav";
import CashBankRecNav from "./Components/Reports/DH_APSHCL/CashBankRecNav";
import CashBankPaymentsNav from "./Components/Reports/DH_APSHCL/CashBankPaymentsNav";
import ApHomesProgressReport from "./Components/HousingReports/ApHomesProgressReport";
import PFMSReleaseStatusReport from "./Components/Reports/PFMSReleaseStatusReport";
import Distwisebudgetlimit from "./Components/EntryForms/GMF1/distwisebudgetlimit";
import BudgetDashboard from "./Components/Reports/DH_APSHCL_GMF1/BudgetDashboard";
import SalaryJVReport from "./Components/Reports/DH_APSHCL/SalaryJVReport";
import BankDetails from "./Components/EntryForms/DH_APSHCL/BankDetails";
import OTSReconsolationReport from "./Components/Reports/DH_APSHCL/OTSReconsolationReport";
import Financeadditionalexpenditurereport from "./Components/Reports/DH_APSHCL/Financeadditionalexpenditurereport";
import EmployeesData from "./Components/Reports/DH_APSHCL/EmployeesData";
import HeadsOpeningBalance from "./Components/EntryForms/DH_APSHCL/HeadsOpeningBalance";
import MGNREGAPaymentStatusReport from "./Components/Reports/DH_APSHCL/MGNREGAPaymentStatusReport";
import BalanceSheet from "./Components/EntryForms/DH_APSHCL/BalanceSheet";
import BankBookUpdate from "./Components/EntryForms/DH_APSHCL/BankBookUpdate";
import OutstandingPayments from "./Components/EntryForms/DH_APSHCL/OutstandingPayments";
import OutstandingReceipts from "./Components/EntryForms/DH_APSHCL/OutstandingReceipts";
import BankACAsperEnteries from "./Components/EntryForms/DH_APSHCL/BankACAsperEnteries";
import BankRenconciliationStatement from "./Components/EntryForms/DH_APSHCL/BankRenconciliationStatement";
import DirectDebitCredit from "./Components/EntryForms/DH_APSHCL/DirectDebitCredit";
import CashFlow from "./Components/EntryForms/DH_APSHCL/CashFlow";
import ProfitandLoss from "./Components/EntryForms/DH_APSHCL/ProfitandLoss";
import DistrictWiseDateLimit from "./Components/EntryForms/GMF1/DistrictWiseDateLimit";
import ClassificationHeads from "./Components/EntryForms/DH_APSHCL/ClassificationHeads";
import SubHeadsOpeningBalance from "./Components/EntryForms/DH_APSHCL/SubHeadsOpeningBalance";
import TrailBalanceReportWithOBs from "./Components/Reports/DH_APSHCL/TrailBalanceReportWithOBs";

export default function LandingPage1({ PrivateRoute }) {
  let user = localStorage.getItem("username");
  let isApshclUser = user === "APSHCL";
  return (
    <>
      <PrivateRoute path={"/Dashboardheader"} component={Dashboardheader} />
      <PrivateRoute path={"/NavigationServicesHeader"} component={NavigationServicesHeader} />
      <PrivateRoute path={"/TokenReceiver"} component={TokenReceiver} />
      <PrivateRoute path={"/LogOut"} component={LogOut} />
      <PrivateRoute path={"/ChangePassword.do"} component={ChangePassword} />
      <PrivateRoute path={"/changeUser.do"} component={ChangeUser} />
      <PrivateRoute path={"/AddService.do"} component={AddService} />
      <PrivateRoute path={"/RoleServiceMapping.do"} component={RoleServiceMapping} />
      <PrivateRoute path={"/BankEntryScreen"} component={BankEntryScreen} />
      <PrivateRoute path={"/ReceiptsInput.do"} component={GenerationReceipt} />
      <PrivateRoute path={"/PaymentsInput.do"} component={GenerationPayment} />
      <PrivateRoute path={"/JournalVockForm.do"} component={GenerationJournal} />
      <PrivateRoute path={"/InterTransfer.do"} component={InterBankTransfer} />
      <PrivateRoute path={"/SubHeadsMaster.do"} component={SubHeadMaster} />
      <PrivateRoute path={"/OnlineReportJV.do"} component={OnlineJournal} />
      <PrivateRoute path={"/SalaryJV.do"} component={SalaryJournal} />
      <PrivateRoute path={"/BankBook.do"} component={BankBook} />
      <PrivateRoute path={"/BankWiseBankBook.do"} component={BankSubsidary} />
      <PrivateRoute path={"/ReceiptsOutput.do"} component={CbReceipts} />
      <PrivateRoute path={"/PaymentsOutput.do"} component={CbPayments} />
      <PrivateRoute path={"/JournalVockReport.do"} component={Jvoucher} />
      <PrivateRoute path={"/HeadWiseDetails"} component={HeadWiseDetails} />
      <PrivateRoute path={"/PayrollReport.do"} component={Confirm_Emp_OnRolls} />
      <PrivateRoute path={"/MonthlyPaybillConfirmation.do"} component={MonthlyPaybillConfirmation} />
      <PrivateRoute path={"/BankBookReport.do"} component={BankBookReport_Apshcl} />
      <PrivateRoute path={"/bankacc_confirm.do"} component={BankAccountConfirm_GMF} />
      <PrivateRoute path={"/EmployeeConfirmation.do"} component={EmployeeConfirmation} />
      <PrivateRoute path={"/ReceiptsPaymentsTotalReport.do"} component={HeadWiseDetails} />
      <PrivateRoute path={"/JournalReport.do"} component={Jregister} />
      <PrivateRoute path={"/GeneralLedger.do"} component={GLedger} />
      <PrivateRoute path={"/ExpenditureAnalysis.do"} component={Expenditure} />
      {!isApshclUser && (<PrivateRoute path={"/DistrictExpenditureAnalysis.do"} component={Expenditure} />)}
      <PrivateRoute path={"/OBCB.do"} component={Review} />
      <PrivateRoute path={"/Cash_BankOBCB.do"} component={Pr_Cb} />
      <PrivateRoute path={"/GeneratedMonthlyPaybill.do"} component={GeneratedMonthlyPayBill} />
      <PrivateRoute path={"/EmpDetailsCommonEdit.do"} component={EmpDetailsCommonEdit} />
      <PrivateRoute path={"/Emp_Pay_Particulars.do"} component={EmployeePayParticulars} />
      <PrivateRoute path={"/DifferencesInPaybill.do"} component={VariationInCalculation} />
      <PrivateRoute path={"/HeadsMaster.do"} component={HeadsMaster} />
      <PrivateRoute path={"/AccountReport.do"} component={BankBalances_Apshcl} />
      <PrivateRoute path={"/SubheadsReport.do"} component={SubLedger} />
      <PrivateRoute path={"/DistrictWiseBudgetLimit.do"} component={Distwisebudgetlimit} />
      <PrivateRoute path={"/journalvoucheredit.do"} component={JourrnalVoucherEdit} />
      <PrivateRoute path={"/HousingExpenditureReport.do"} component={HousingExpenditureReport} />
      <PrivateRoute path={"/Npiincomereport.do"} component={HousingIncomeReport} />
      <PrivateRoute path={"/NPIphysicalProgressArchieveHO"} component={NpiPhysicalProgressReport} />
      <PrivateRoute path={"/aphomesBenPaymentReport.do"} component={ApHomesBeneficiaryPaymentReport} />
      <PrivateRoute path={"/ApHomesProgressReport"} component={ApHomesProgressReport} />
      <PrivateRoute path={"/StageUpdatePaymentsReport.do"} component={PaymentCementReleased} />
      <PrivateRoute path={"/MaterialPatchDetails.do"} component={MaterialPatchDetails} />
      <PrivateRoute path={"/MaterialtypeDetails.do"} component={MaterilaTypeDetails} />
      <PrivateRoute path={"/DistrictwiseTransfer.do"} component={DistrictwiseTransfer_Gmadm} />
      <PrivateRoute path={"/Payroll.do"} component={NewEmpRegistration} />
      <PrivateRoute path={"/DistrictwiseDesignationCount.do"} component={DistrictwiseDesignationCount} />
      <PrivateRoute path={"/DistrictsPayBill.do"} component={EmpDataCount} />
      <PrivateRoute path={"/UpdateGeneratedPaybill.do"} component={UpdateGeneratePaybill} />
      <PrivateRoute path={"/JournalVoucherRepNav"} component={JournalVoucherRepNav} />
      <PrivateRoute path={"/CashBankRecNav"} component={CashBankRecNav} />
      <PrivateRoute path={"/CashBankPaymentsNav"} component={CashBankPaymentsNav} />
      <PrivateRoute path={"/PFMSReleaseStatusReport"} component={PFMSReleaseStatusReport} />
      {/* <PrivateRoute path={"/distwisebudgetlimit"} component={Distwisebudgetlimit} /> */}
      <PrivateRoute path={"/BudgetDashboard"} component={BudgetDashboard} />
      <PrivateRoute path={"/SalaryOnlineJVReport.do"} component={SalaryJVReport} />
      <PrivateRoute path={"/bankentry.do"} component={BankDetails} />
      <PrivateRoute path={"/OTSReconsolationReport"} component={OTSReconsolationReport} />
      <PrivateRoute path={"/Financeadditionalexpenditurereport"} component={Financeadditionalexpenditurereport} />
      <PrivateRoute path={"/EmployeesData"} component={EmployeesData} />
      <PrivateRoute path={"/HeadsOpeningBalance"} component={HeadsOpeningBalance} />
      <PrivateRoute path={"/MGNREGAPaymentStatusReport"} component={MGNREGAPaymentStatusReport} />
      <PrivateRoute path={"/BalanceSheet"} component={BalanceSheet} />
      <PrivateRoute path={"/BankBookUpdate"} component={BankBookUpdate} />
      <PrivateRoute path={"/OutstandingPayments"} component={OutstandingPayments} />
      <PrivateRoute path={"/OutstandingReceipts"} component={OutstandingReceipts} />
      <PrivateRoute path={"/BankACAsperEnteries"} component={BankACAsperEnteries} />
      <PrivateRoute path={"/BankRenconciliationStatement"} component={BankRenconciliationStatement} />
      <PrivateRoute path={"/DirectDebitCredit"} component={DirectDebitCredit} />
      <PrivateRoute path={"/CashFlow"} component={CashFlow} />
      <PrivateRoute path={"/ProfitandLoss"} component={ProfitandLoss} />
      <PrivateRoute path={"/DistrictWiseDateLimit"} component={DistrictWiseDateLimit} />
      <PrivateRoute path={"/ClassificationHeads"} component={ClassificationHeads} />
      <PrivateRoute path={"/SubHeadsOpeningBalance"} component={SubHeadsOpeningBalance} />
      <PrivateRoute path={"/TrailBalanceReportWithOBs"} component={TrailBalanceReportWithOBs} />
      

      
      
      
      
      
    </>
  );
}